import { Component } from 'react';
import DatePicker from 'react-datepicker';
import { addCSSDynamically } from '../../utils';
import { CDN_CLRSAVE_URL } from '../../constants';

interface Props {
  selected: string;
  minDate: string;
  maxDate: string;
  onChange: Function;
}

const changeStringToDate = (date: string) => {
  if (date) {
    return new Date(date);
  }
};

class DateSelector extends Component<Props> {
  public componentDidMount() {
    addCSSDynamically(
      `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1574860462_datepicker.css`
    );
  }

  public render() {
    const { selected, onChange, minDate, maxDate } = this.props;
    return (
      <DatePicker
        selected={changeStringToDate(selected)}
        minDate={changeStringToDate(minDate)}
        maxDate={changeStringToDate(maxDate)}
        onChange={onChange}
        dateFormat="yyyy-MM-dd"
        placeholderText="Select a date"
      />
    );
  }
}

export default DateSelector;



// WEBPACK FOOTER //
// ./components/ui/dateSelector.tsx